import { useQuery } from "@tanstack/react-query";
import { getQuotaUsageQueryKey } from "../queryKeys";
import api from "../../../services/api";
import { IUsageResponse } from "../@types/quotausage";

const REFETCH_INTERVAL = 10 * 1000;

const useQuotaUsage = (): {
  enabled: boolean;
  usage: IUsageResponse;
  someExceeded: boolean;
} => {
  const { data } = useQuery({
    queryKey: getQuotaUsageQueryKey,
    queryFn: () => api.getTiCloudUsage(),
    refetchInterval: REFETCH_INTERVAL
  });

  const {
    enabled,
    usage = {},
    some_exceeded: someExceeded = false
  } = data?.data || {};

  return { enabled, usage, someExceeded };
};

export default useQuotaUsage;
